import { PHONE, EMAIL } from "@/lib/constants";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1A243B] text-[#EBEBFA]">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-12 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
        <div>
          <p className="font-display font-bold text-xl">Ready <span className="italic">&amp;</span> Right Testing Services</p>
          <p className="text-[#EBEBFA]/70 text-sm mt-1">Homeschool testing, done right.</p>
        </div>
        <div className="text-sm text-[#EBEBFA]/80 space-y-1">
          <p>{PHONE} · {EMAIL}</p>
          <p>Serving Oregon &amp; Washington families since 1996.</p>
        </div>
        <a data-testid="footer-book-btn" href="#book" className="cta-pill inline-block bg-[#FFC107] text-[#1A243B] text-sm font-bold px-6 py-2.5 rounded-full w-fit">
          Book online
        </a>
      </div>
    </footer>
  );
}
